import React, { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import AdminLayout from '../../layouts/admin.layout';
import { useDeliveries } from '../hooks';
import { DeliveriesTable, DateRangeSelector } from '../components';
import { DateRangeParams } from '../types';
import './deliveries.screen.css';

const DeliveriesScreen: React.FC = () => {
  const { deliveries, loading, error, fetchDeliveriesByDateRange } = useDeliveries();
  const toast = useRef<Toast>(null);
  const [currentParams, setCurrentParams] = useState<DateRangeParams | null>(null);

  // Mostrar mensaje de error
  const showError = (message: string) => {
    toast.current?.show({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 3000
    });
  };

  // Manejar búsqueda por rango de fechas
  const handleSearch = async (params: DateRangeParams) => {
    setCurrentParams(params);
    try {
      const success = await fetchDeliveriesByDateRange(params);
      if (!success) {
        showError('No se pudieron cargar las entregas');
      }
    } catch (err) {
      showError('Error al buscar entregas');
    }
  };

  // Manejar actualización de entregas después de crear/cancelar guía
  const handleDeliveryUpdated = async () => {
    if (currentParams) {
      try {
        const success = await fetchDeliveriesByDateRange(currentParams);
        if (!success) {
          showError('No se pudo actualizar la lista de entregas');
        }
      } catch (err) {
        showError('Error al actualizar la lista de entregas');
      }
    }
  };

  return (
    <AdminLayout>
      <div className="deliveries-screen">
        <Toast ref={toast} />

        <DateRangeSelector 
          onSearch={handleSearch}
          loading={loading}
        />

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}

        <DeliveriesTable 
          deliveries={deliveries} 
          loading={loading} 
          onDeliveryUpdated={handleDeliveryUpdated}
        />
      </div>
    </AdminLayout>
  );
};

export default DeliveriesScreen; 